import { FC } from "react"
import { Attention } from "../../../module/attentions/containers/attention"

export const AttentionPage: FC = () => <Attention />
